export const comparableVehicleCategories = ["energy", "insurance", "road_tax", "interest", "leasing"];

/** Same booked total as the economy vehicle cards: linked comparable categories only. */
export function bookedComparableTotal(data, categories = comparableVehicleCategories) {
  if (!data?.mapped) return null;
  const hasLinked = categories.some((key) => data.mapped.some((row) => row.category === key));
  if (!hasLinked) return null;
  return categories.reduce((sum, key) => {
    const linked = data.mapped.some((row) => row.category === key);
    return linked ? sum + Number(data.totals?.[key] || 0) : sum;
  }, 0);
}

export function estimatedOperatingCost(estimate) {
  return estimate?.available ? estimate.operating_cost : null;
}

export function vehicleCostDifference(estimated, booked) {
  return estimated != null && booked != null ? booked - estimated : null;
}
